/**
 * Treat — show only the selected variant's images in the product gallery.
 *
 * Each gallery slide and thumbnail carries data-variant-owners (comma-separated variant ids,
 * empty for images shared by every variant), written by snippets/treat-product-media-gallery.
 * On load and on every variant change this hides the other variants' images in both the main
 * slider and the thumbnail strip, then asks Sense's sliders to recount their pages.
 */
(() => {
  const apply = (gallery, variantId) => {
    if (!gallery || !variantId) return;
    const id = String(variantId);
    const items = Array.from(gallery.querySelectorAll('[data-variant-owners]'));
    let anyVisible = false;
    items.forEach((item) => {
      const owners = (item.dataset.variantOwners || '').trim();
      const visible = owners === '' || owners.split(',').includes(id);
      item.classList.toggle('hidden', !visible);
      if (visible) anyVisible = true;
    });
    // A variant with no images of its own (and no shared images) would leave an empty gallery:
    // show everything instead.
    if (!anyVisible) items.forEach((item) => item.classList.remove('hidden'));
    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  };

  const initialVariantId = (gallery) => {
    const scope = gallery.closest('product-info') || document;
    const input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"], form input[name="id"]');
    return input ? input.value : null;
  };

  const start = () => {
    document.querySelectorAll('media-gallery[data-filter-variant-media]').forEach((gallery) => {
      apply(gallery, initialVariantId(gallery));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || !data.variant) return;
        apply(document.getElementById(`MediaGallery-${data.sectionId}`), data.variant.id);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
